<template>
  <v-container v-if="cook" class="mt-3" flexbox center>
     
    <!-- Cook Card -->
    <v-row>
      <v-col md="12" cols="12">
        <h1>{{cook.name}}</h1>
      </v-col>
    </v-row>
    <v-row>
      <v-col md="6" cols="12">
        <iframe width="100%" height="450" :src="cook.videoUrl.replace('https://youtu.be/', 'https://www.youtube.com/embed/')" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
      </v-col>

      <v-col md="6" cols="12">

        <v-row>
          <v-col md="12" cols="12">
           <b> التصنيفات:</b>
            <span v-for="category in cook.categories" :key="category.name">
              <v-chip class="ma-2" color="#EFAA42">{{category.name}}</v-chip>
            </span>
          </v-col>
        </v-row>

         <v-row>
          <v-col md="12" cols="12">
            <b> المطبخ: </b>
            <span v-for="country in cook.countries" :key="country.name">
              <v-chip class="ma-2" color="#EFAA42">{{country.name}}</v-chip>
            </span>
          </v-col>
        </v-row>

        <v-divider></v-divider>
         <v-row>
          <v-col md="12" cols="12">
            <v-row>
              <v-col md="12" cols="12">
                <h1>المقادير</h1>
              </v-col>
            </v-row>

            <v-row>
               <v-col md="12" cols="12">
                <span v-for="ing in cook.ingredients" :key="ing.name">
                  {{ing.name}}, 
                </span>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>


  </v-container>
</template>

<script>
import { mapGetters } from "vuex";
import { GET_COOK } from "../../graphql/Cooks";

export default {
  name: "Cook",
  props: ["cookId"],
  data() {
    return {
      dialog: false,
      messageBody: ''
    };
  },
  apollo: {
    cook: {
      query: GET_COOK,
      variables() {
        return {
          id: this.cookId
        };
      }
    }
  },
  computed: {
    ...mapGetters(["user"])
  },
  methods: {
    goToPreviousPage() {
      this.$router.go(-1);
    },
    toggleImageDialog() {
      if (window.innerWidth > 500) {
        this.dialog = !this.dialog;
      }
    }
  }
};
</script>

<style scoped>
#cook__image {
  height: 400px !important;
}
</style>
